import React from "react";
import PropTypes from "prop-types";

import { Box, Breadcrumbs } from "shipnow-mercurio";

import { ROUTES_MAP } from "../constants/routes.consts";
import { useStore } from "../../../stores/AppStore";

import { SectionHeader } from ".";

const DEFAULT_PROPS = {
  breadcrumbsProps: {
    currentLabel: "",
  },
  bottomComponent: null,
  isMobile: false,
  padding: "b-24 t-8",
  sectionHeader: {
    buttonsGroup: null,
    titleProps: {
      children: "title",
      padding: "t-8",
    },
  },
};

export const PageHeader = (props) => {
  //? merge default attrs with attrs.
  const attrs = {
    ...DEFAULT_PROPS,
    ...props,
    breadcrumbsProps: {
      ...DEFAULT_PROPS.breadcrumbsProps,
      ...props.breadcrumbsProps,
    },
    sectionHeader: {
      ...DEFAULT_PROPS.sectionHeader,
      ...props.sectionHeader,
      titleProps: {
        ...DEFAULT_PROPS.sectionHeader.titleProps,
        ...props.sectionHeader?.titleProps,
      },
    },
  };

  const { currentLabel, ...othersBreadcrumbsProps } = attrs.breadcrumbsProps;
  const store = useStore();

  React.useEffect(() => {
    document.title = `${store.printNewsCounter()} ${
      attrs.sectionHeader.titleProps.children
    } - shipnow`;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store.ui, store.newsCounter, attrs.sectionHeader.titleProps.children]);

  return (
    <Box padding={attrs.padding}>
      {!!currentLabel && (
        <Breadcrumbs
          {...othersBreadcrumbsProps}
          currentLabel={`#${currentLabel}`}
          routeMap={ROUTES_MAP}
        />
      )}

      <SectionHeader
        buttonComponent={attrs.sectionHeader.buttonsGroup}
        textProps={{
          maxLength: attrs.isMobile ? 0 : 35,
          size: attrs.isMobile ? "subtitle" : "pageTitle",
          wordBreak: attrs.isMobile ? "break-word" : "normal",
          ...attrs.sectionHeader.titleProps,
        }}
      />

      {!!attrs.bottomComponent && <attrs.bottomComponent />}
    </Box>
  );
};

PageHeader.propTypes = {
  breadcrumbsProps: PropTypes.shape({
    currentLabel: PropTypes.string,
  }),
  bottomComponent: PropTypes.func,
  isMobile: PropTypes.bool,
  sectionHeader: PropTypes.shape({
    buttonsGroup: PropTypes.func,
    titleProps: PropTypes.shape({
      children: PropTypes.string,
      padding: PropTypes.string,
    }),
  }),
  padding: PropTypes.string,
};
